module.exports = __webpack_public_path__ + "img/inactive-state.ea77c22e.svg";